export default {
  user_right_success: (email, rights) => {
    const [key, val] = Object.entries(rights)[0]
    return `Successfully changed ${email}'s role ${key} to ${val}.`
  },
}
